import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
const state = {
  serviceRequest: {
    date: new Date(),
    userId: null,
    isOnSite: true,
    createdBy: null,
    serviceJobsMeta: [],
    customerCall: false,
    isSiteVisited: false,
    externalGoodsMeta: {},
    externalGoodsTotal: 0,
    priority: "moderate",
    saleId: null,
    customerAddressId: null,
    temporaryPhone: ""
  },
  serviceRequestList: [],
  serviceRequestLogs: []
};

const serviceRequest = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default serviceRequest;
